export const REMOTE_STALL_MS = 5_000

export function remoteCameraIssue(opts: {
  streamState: 'active' | 'paused' | 'unknown' | string
  lastDecodedAt: number | null
  watchingSince: number
  now: number
  intendedOn: boolean
  subscribed: boolean
}): 'paused' | 'stalled' | null {
  if (!opts.intendedOn || !opts.subscribed) return null
  if (opts.streamState === 'paused') return 'paused'

  const lastProgressAt = opts.lastDecodedAt ?? opts.watchingSince
  return opts.now - lastProgressAt >= REMOTE_STALL_MS ? 'stalled' : null
}
